import { render, staticRenderFns } from "./workshop.vue?vue&type=template&id=0bccb561&scoped=true&"
import script from "./workshop.vue?vue&type=script&lang=ts&"
export * from "./workshop.vue?vue&type=script&lang=ts&"
import style0 from "./workshop.vue?vue&type=style&index=0&id=0bccb561&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bccb561",
  null
  
)

export default component.exports